import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      borderRadius: "0 0 8px 8px",
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      height: "auto",
      borderTop: `4px solid ${theme.palette.info.dark}`
    },
    header: {
      padding: "8px 0px 8px 32px",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      flexDirection: "column",
      "& .MuiTypography-root": {
        color: "white"
      },
      "& .MuiTypography-caption": {
        fontSize: "1rem",
        lineHeight: "1.6rem"
      },
      "& .MuiTypography-h6": {
        lineHeight: "2.4rem"
      }
    },
    headerText: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px"
    },
    headerTextBold: {
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "24px"
    },
    searchBox: {
      padding: "24px 24px 16px 24px"
    },
    negativeMargin: {
      margin: "-1.2rem -0.6rem !important",
      gap: "1rem !important"
    },
    gridPadding: {
      padding: ".6rem 0 !important"
    },
    btnContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 0px 12px 0px",
      margin: " 0px 24px 0px 24px "
    },
    successMessage: {
      color: theme.palette.success.main
    },
    info: {
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      "& >img": {
        marginRight: 10
      }
    },
    btn: {
      maxWidth: "188px !important",
      maxHeight: 40,
      flex: 1,
      "& .MuiTypography-root": {
        color: "inherit"
      }
    },
    btnSearch: {
      minWidth: "288px !important",
      maxHeight: 40,
      backgroundColor: "#009FB8 !important",
      flex: 1,
      "& .MuiTypography-root": {
        color: "inherit"
      }
    },
    btnTxt: {
      lineHeight: "22px",
      fontSize: "14px"
    },
    gradeWrapper: {
      paddingTop: `24px`
    },
    label: {
      marginBottom: "4px"
    },
    flex: {
      display: "flex",
      padding: ".6rem !important"
    },
    button: {
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        "& button": {
          margin: "10px 0"
        }
      }
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    required: {
      color: theme.palette.error.main,
      "& :after": {
        content: "*"
      }
    },
    messageIcon: { marginRight: "5px" },
    note: {
      fontSize: "14px",
      color: "#000000",
      display: "flex",
      alignItems: "center"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "end",
      gap: "1rem"
    },
    boxContainer: {
      display: "flex",
      justifyContent: "space-between",
      padding: ".6rem 0 !important",
      gap: "1rem !important"
    },
    warningBox: {
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      padding: "0 !important"
    },
    warningDiv: {
      display: "flex",
      width: "50%",
      paddingLeft: "6px"
    },
    warningNote: {
      fontSize: "12px",
      color: "#007E92"
    },
    emptyMessage: {
      fontSize: "14px",
      color: "#FF2600",
      display: "flex",
      alignItems: "center"
    },
    inputTextField: {
      width: "100%",
      paddingRight: "8px !important"
    }
  }),
  { name: "EditMaterial" }
);

export default useStyles;
